import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import SelectField from '@wix/da-ds/pkg/Dropdown/select/SelectField';
import { DropdownOption } from '@wix/da-ds/pkg/Dropdown/types';
import { AnswerType, QuestionFieldName } from '../../types';

interface Props {}

const AnswerTypeField: React.FC<Props> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name: QuestionFieldName.ANSWER_TYPE, control });

  const items: DropdownOption[] = [
    {
      label: t('originalDeviationPopup.questionnaire.form.answerType.freeText'),
      value: AnswerType.FREE_TEXT,
      selected: value === AnswerType.FREE_TEXT,
    },
    {
      label: t(
        'originalDeviationPopup.questionnaire.form.answerType.singleChoice'
      ),
      value: AnswerType.SINGLE_CHOICE,
      selected: value === AnswerType.SINGLE_CHOICE,
    },
    {
      label: t(
        'originalDeviationPopup.questionnaire.form.answerType.multipleChoice'
      ),
      value: AnswerType.MULTIPLE_CHOICE,
      selected: value === AnswerType.MULTIPLE_CHOICE,
    },
  ];

  return (
    <SelectField
      id={id}
      label={t('originalDeviationPopup.questionnaire.form.answerType.label')}
      items={items}
      value={value}
      onChange={onChange}
      withBlankOption={false}
    />
  );
};
AnswerTypeField.displayName = 'AnswerTypeField';

export default AnswerTypeField;
